export enum DRAWER_TYPE {
  CampaingAdSetAdDetails = "CampaingAdSetAdDetails",
  ExperimentsForm = "ExperimentsForm",
  ProductDetails = "ProductDetails",
  /** Comment moderation: one ad's audience read and its judged comments. */
  AdComments = "AdComments",
}

export type TDrawerConfig = {
  type: DRAWER_TYPE
  props: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
  clickSourceId: string
}
